// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8625f1c0","667":"bef86698","915":"7b010c2c","943":"4cf51322"}[chunkId] + ".chunk.js";
};